export default __webpack_public_path__ + "static/media/administrating.b252639c.gif";